// extracted by mini-css-extract-plugin
export default {"privacySection":"policy_privacySection__5RJKg"};